import apiClient from "../../axios/apiClient";



export const getTripReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc", jenId = "", vendorId = "", 
    vehicleId = "", driverId = "", startDate = "", endDate = "") =>
  async (dispatch) => {
    try
    {
      dispatch({ type: "GET_TRIP_REPORT_PENDING" });

      const response = await apiClient.get(
        `/api/v1/verified-report/trip`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            jenId: jenId,
            vendorId: vendorId,
            vehicleId: vehicleId,
            driverId: driverId,
            startDate: startDate,
            endDate: endDate,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_TRIP_REPORT_FULFILLED",
        payload: response.data?.data,
        reportCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    }
    catch (error)
    {
      dispatch({
        type: "GET_TRIP_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };


export const getRevenueReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc", jenId = "", vendorId = "", 
    vehicleId = "", driverId = "", startDate = "", endDate = "") =>
  async (dispatch) => {
    try
    {
      dispatch({ type: "GET_REVENUE_REPORT_PENDING" });

      const response = await apiClient.get(
        `/api/v1/verified-report/revenue`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            jenId: jenId,
            vendorId: vendorId,
            vehicleId: vehicleId,
            driverId: driverId,
            startDate: startDate,
            endDate: endDate,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_REVENUE_REPORT_FULFILLED",
        payload: response.data?.data,
        reportCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    }
    catch (error)
    {
      dispatch({
        type: "GET_REVENUE_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMonthlyRevenueReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc", jenId = "", vendorId = "", 
    vehicleId = "", driverId = "", startDate = "", endDate = "") =>
  async (dispatch) => {
    try
    {
      dispatch({ type: "GET_MONTHLY_REVENUE_REPORT_PENDING" });

      const response = await apiClient.get(
        `/api/v1/verified-report/monthly-revenue`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            jenId: jenId,
            vendorId: vendorId,
            vehicleId: vehicleId,
            driverId: driverId,
            startDate: startDate,
            endDate: endDate,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MONTHLY_REVENUE_REPORT_FULFILLED",
        payload: response.data?.data,
        reportCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    }
    catch (error)
    {
      dispatch({
        type: "GET_MONTHLY_REVENUE_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };


  export const getCircleReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc", startDate = "", endDate = "",userTypeId=13) =>
  async (dispatch) => {
    try
    {
      dispatch({ type: "GET_TRIP_REPORT_PENDING" });

      const response = await apiClient.get(
        `/api/v1/other-report/circle-report`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            startDate: startDate,
            endDate: endDate,
            usertypeId:userTypeId
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_BOOKING_TRIP_REPORT_FULFILLED",
        payload: response.data,
        reportCount: response.data?.count,
      });
    }
    catch (error)
    {
      dispatch({
        type: "GET_TRIP_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };


  export const getCircleVehicleReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc", startDate = "", endDate = "",userTypeId=13) =>
  async (dispatch) => {
    try
    {
      dispatch({ type: "GET_TRIP_REPORT_PENDING" });

      const response = await apiClient.get(
        `/api/v1/other-report/circle-report/vehicle`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            startDate: startDate,
            endDate: endDate,
            usertypeId:userTypeId
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_TRIP_REPORT_FULFILLED",
        payload: response.data,
        reportCount: response.data?.pagination?.total,
        permissions: response.data?.permissions,
      });
    }
    catch (error)
    {
      dispatch({
        type: "GET_TRIP_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };
